export const obesityAnalysisData = [
    {
        key: 'bmi',
        name: 'BMI',
        unit: 'kg/m2',
        minValue: 0,
        maxValue: 99,
        normalRange: [],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'bmiLower',
        normalMaxValueKey: 'bmiUpper',
        deltaValueKey: 'deltaBMI',
    },
    {
        key: 'bfm',
        name: '體脂肪',
        unit: 'kg',
        minValue: 0,
        maxValue: 99,
        normalRange: [],
        minValueKey: '',
        maxValueKey: '',
        normalMinValueKey: 'bfmLower',
        normalMaxValueKey: 'bfmUpper',
        deltaValueKey: 'deltaBFM',
    },
];

export default obesityAnalysisData;
